import React from "react";
import {
  FormField,
  Input,
  InputProps,
} from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";

interface InputFieldProps {
  label: string;
  errText?: string;
  value: string;
  disabled: boolean;
  type: "text" | "password" | "email";
  onChange?: ({ detail }: { detail: InputProps.ChangeDetail }) => void;
}

interface UsernameFieldProps {
  errText?: string;
  username: string;
  disabled: boolean;
  onChange?: ({ detail }: { detail: InputProps.ChangeDetail }) => void;
}

interface PasswordFieldProps {
  label: string;
  errText?: string;
  password: string;
  onChange: ({ detail }: { detail: InputProps.ChangeDetail }) => void;
}

interface CodeFieldProps {
  errText?: string;
  code: string;
  onChange: ({ detail }: { detail: InputProps.ChangeDetail }) => void;
}

const InputField = ({
  label,
  errText,
  value,
  disabled,
  type,
  onChange,
}: InputFieldProps) => {
  return (
    <FormField label={label} errorText={errText}>
      <Input
        value={value}
        disabled={disabled}
        type={type}
        onChange={onChange}
      />
    </FormField>
  );
};

export const UsernameField = ({
  errText,
  username,
  disabled,
  onChange,
}: UsernameFieldProps) => {
  return (
    <InputField
      label={LABELS.EMAIL_ADDRESS}
      errText={errText}
      value={username}
      disabled={disabled}
      type="email"
      onChange={onChange}
    />
  );
};

export const PasswordField = ({
  label,
  errText,
  password,
  onChange,
}: PasswordFieldProps) => {
  return (
    <InputField
      label={label}
      errText={errText}
      value={password}
      disabled={false}
      type="password"
      onChange={onChange}
    />
  );
};

export const CodeField = ({ errText, code, onChange }: CodeFieldProps) => {
  return (
    <InputField
      label={LABELS.VERIFICATION_CODE}
      errText={errText}
      value={code}
      disabled={false}
      type="text"
      onChange={onChange}
    />
  );
};
